import { Component, OnInit, Inject } from '@angular/core';
import { BookAppointment, HospitalDetails, ReferralSourceDtls, CommunicationDetails } from '../Class/BookAppointment';
import { GlobalService } from '../global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
@Component({
  selector: 'app-book-appointment',
  templateUrl: './book-appointment.component.html',
  styleUrls: ['./book-appointment.component.css']
})

export class BookAppointmentComponent implements OnInit {

  private bookAppointment: BookAppointment;
  private hospitalDetails: HospitalDetails;
  private referralSourceDtls: ReferralSourceDtls;
  private communicationDetails: CommunicationDetails;
  httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
  options = {
    headers: this.httpHeaders
  }; 
  DoctorSlots;
  SelectedHospital;
  SelectedDoctor;
  SlectedSlots;
  maxDate: Date;
  myform: FormGroup;
  firstName: FormControl;
  lastName: FormControl;
  email: FormControl;
  mobile: FormControl;
  gender: FormControl;
  datePicker: FormControl;

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private router: Router,private globalService: GlobalService) {
  }

  ngOnInit() {
    this.baseUrl = environment.baseUrl;
    this.maxDate = new Date();
    this.createFormControls();
    this.createForm();
    this.DoctorSlots = this.globalService.getData();
    this.SelectedHospital = this.globalService.getHospitalInfo();
    this.SelectedDoctor = this.globalService.getDoctorInfo();
    this.SlectedSlots = this.globalService.getSlecetdSolts();
    this.bookAppointment = new BookAppointment();
    this.hospitalDetails = new HospitalDetails(); 
    this.referralSourceDtls = new ReferralSourceDtls();  
    this.communicationDetails = new CommunicationDetails();
    
    
    
  }

  createFormControls() {
    this.firstName = new FormControl('', Validators.required);
    this.lastName = new FormControl('', Validators.required);
    this.datePicker = new FormControl('', Validators.required);
    this.email = new FormControl('', [     
      Validators.pattern("[^ @]*@[^ @]*")
    ]);
    this.mobile = new FormControl('', [      
      Validators.maxLength(10)
    ]);
    this.gender = new FormControl('', Validators.required);
  }

  createForm() {
    this.myform = new FormGroup({    
        firstName: this.firstName,
        lastName: this.lastName,     
      email: this.email,
      mobile: this.mobile,
      gender: this.gender,
      datePicker: this.datePicker
    });
  }
  Previous() {
    this.router.navigate(['/Appointment/' + this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID]);
  }
  BookAppointment() {
    this.bookAppointment.AppointmentID = 0;
    this.bookAppointment.ParentAppointmentId = 0;
    this.bookAppointment.RootAppointmentId = 0;
    this.bookAppointment.AppointmentStatus = 'B';
    this.bookAppointment.StartTime = this.SlectedSlots.StartTime;
    this.bookAppointment.EndTime = this.SlectedSlots.Endtime; 
    this.bookAppointment.DoctorID = this.SelectedDoctor.DoctorID; 
    this.bookAppointment.DayCD = this.DoctorSlots.calendarList[0].SlotLst[0].DayCD; 
    this.bookAppointment.VisitUserTypeID = "4";
    this.bookAppointment.ConsultationDt = this.DoctorSlots.calendarList[0].consultationDt;
    this.bookAppointment.UserBranchId = this.DoctorSlots.UserBranchId; 
    this.bookAppointment.PatientID = 0;
    this.bookAppointment.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.bookAppointment.UserId = 0;
    this.bookAppointment.USRType = "DOCTOR";
    this.bookAppointment.DoctorVisitRsnID = "4";
    this.hospitalDetails.HospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID;

    this.hospitalDetails.ParentHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.ParentOrganizationId;
    this.hospitalDetails.IsSMSInd = this.SelectedHospital.HospitalInfo.HospitalDetails.IsSMSInd;
    this.hospitalDetails.SenderId = this.SelectedHospital.HospitalInfo.HospitalDetails.SenderId;
    this.hospitalDetails.LoginHospitalID = this.SelectedHospital.HospitalInfo.HospitalDetails.HospitalID; //sms purpose only
    this.bookAppointment.HospitalDetails = this.hospitalDetails;

    this.referralSourceDtls.ReferralID = 0; 
    this.referralSourceDtls.SubReferralID = 2; 
   

    this.bookAppointment.ReferralSourceDtls = this.referralSourceDtls;
    
    this.communicationDetails.PatientName = this.bookAppointment.FirstName + ' ' + this.bookAppointment.LastName;
    this.communicationDetails.PatientMobile = this.bookAppointment.PatientMobile;
    this.communicationDetails.DoctorMobile = this.SelectedDoctor.MobileNo;
    this.communicationDetails.DoctorName = this.SelectedDoctor.FullName;
    this.communicationDetails.AppDate = this.DoctorSlots.calendarList[0].consultationDt;
    this.communicationDetails.AppTime = this.SlectedSlots.StartTime;
    this.communicationDetails.AppToken = this.SlectedSlots.TokenNumber;
    this.communicationDetails.PatientEmail = this.bookAppointment.PatientEmail;  
    this.communicationDetails.DoctorEmail = this.SelectedDoctor.EmailId;  
    this.communicationDetails.HospitalContact = this.SelectedHospital.HospitalInfo.HospitalDetails.MobileNumber;
    this.communicationDetails.BrnachAddress = this.SelectedHospital.HospitalInfo.HospitalAddress;
    this.communicationDetails.CommunicationEmailId = this.SelectedDoctor.CommunicationEmailId || "";
    this.communicationDetails.CommunicationMobileNo = this.SelectedDoctor.CommunicationMobileNo || "";  

    this.bookAppointment.CommunicationDetails = this.communicationDetails;
    this.bookAppointment.PreviousAppointmentDate = "";
    this.bookAppointment.IsFollowUp = false;
    this.bookAppointment.SendDocSms = true; 
    this.bookAppointment.SendDocEmail = true; 
    this.bookAppointment.SendPatientEmail = true; 
    this.bookAppointment.SendPatientSms = true;   
    this.bookAppointment.PatientTypeId = 1;   
    this.bookAppointment.PatientTitle = "Mr";   
    this.bookAppointment.PaidFollowup = false;   



    

    
    console.log(JSON.stringify(this.bookAppointment));
    
    this.http.post<any>(this.baseUrl + "/api/Patient/AddUpdateAppointmentNew", this.bookAppointment, this.options).subscribe(result => {
      
      this.router.navigate(['/Sucess']);
    }, error => console.error(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/book-appointment/book-appointment.component.ts